<template>
  <div class="mt-4">
    <h1 class="text-xl">Verify Following of Account</h1>
    <div class="mt-4">
      <p>
        In order to participate on this campaign you have to follow an account
        <a
          target="_blank"
          data-analytics-click-id="user_account_handle_clicked"
          data-analytics-event-name="user_follow_account_clicked"
          :data-analytics-x-handle-to-follow="handle"
          :href="`https://x.com/${handle}`"
          rel="noopener noreferrer"
          class="text-purple"
        >
          @{{ handle }}
        </a>
        on X.
      </p>

      <!-- Mobile message - hidden on md screens and above -->
      <p v-if="isMobile" class="mt-2">
        To complete the verification, please use a desktop computer (Windows,
        Mac, or Linux). Mobile devices aren't supported yet.
      </p>

      <!-- Desktop message and button - hidden on small screens -->
      <template v-else>
        <p class="mt-2">
          If you’re following the account, click the button below to verify it.
        </p>

        <div class="mt-4">
          <a
            data-analytics-click-id="button_verify_following_sidebar_verify_following_clicked"
            data-analytics-event-name="user_following_verification_attempted"
            :data-analytics-account-handle="handle"
            target="_blank"
            :href="vouchUrl"
            rel="noopener noreferrer"
            class="btn bg-purple-light text-black"
          >
            Verify Following
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { FollowingOfXAccountSidebarProps } from "~/common/Types";
import { getVouchUrl } from "~/utils/vouch";
import { ref, onMounted, onBeforeUnmount } from "vue";

const props = defineProps<FollowingOfXAccountSidebarProps>();

const vouchUrl = ref("");
const isMobile = ref(false);

onMounted(() => {
  // Check if device is a mobile device based on user agent
  // checkDeviceType();

  vouchUrl.value = getVouchUrl({
    verificationId: props.verification_id,
    redirectUrlPathname: `campaign/${props.campaignWeekId}`,
    redirectUrlSearchParams: new URLSearchParams({
      // this requires an ugly hack in default.vue onMounted to keep the param in url
      follow_redirect: "true",
    }),
    handle: props.handle,
  });

  trackEvent("ui_verify_following_sidebar_opened", {
    trigger: "button_verify_following_sidebar_verify_now_clicked",
  });
});

onBeforeUnmount(() => {
  trackEvent("ui_verify_following_sidebar_closed", {
    trigger: "button_verify_following_sidebar_dismiss_clicked",
  });
});

// Function to check if the device is a mobile device based on user agent
const checkDeviceType = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  // Check for common mobile operating systems
  const isMobileOS =
    /android/.test(userAgent) ||
    /iphone/.test(userAgent) ||
    /ipad/.test(userAgent) ||
    /ipod/.test(userAgent) ||
    /blackberry/.test(userAgent) ||
    /windows phone/.test(userAgent);

  isMobile.value = isMobileOS;
};
</script>
